export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M9 2v5.31l-1-1V2H1v12h7v-3.39l1-1V14h6V2H9zm0 13H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v12c0 .52-.39.94-.9.99H9V15zM5.72 6.15c.2-.2.51-.2.71 0l1.93 1.93c.11.09.17.23.17.38 0 .13-.05.26-.15.36l-1.96 1.96c-.2.2-.51.2-.71 0-.2-.2-.2-.51 0-.71l1.11-1.11H2.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h4.32l-1.1-1.1c-.2-.2-.2-.51 0-.71z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};